import { ref } from 'vue'
import { MdTypography, MdIconClose } from '@antiqua-dls/vue-components'

import CrossIcon from '../icons/cross-icon/index.vue'

export default {
  components: {
    CrossIcon,
    MdTypography,
    MdIconClose
  },

  props:{
    criteriaTitle:{
      type:String,
      default:''
    },
    criteria:{
      type:String,
      default: ''
    }
  },

  data() {
    return {
      minHeight: process.env.MIN_IMAGE_HEIGHT,
      minWidth: process.env.MIN_IMAGE_WIDTH
    }
  },

  emits: ['update:thingsToKeepModal'],

  setup(props,{emit}){
    const uploadImageDescriptionLength = ref(5)
    const closeImageInfo = () => {
      emit('update:thingsToKeepModal')
    }

    return {
      uploadImageDescriptionLength,
      closeImageInfo
    }
  }
}
